import { render, staticRenderFns } from "./ChainsBonusGamePreview.vue?vue&type=template&id=b0af2fb4&lang=pug&"
import script from "./ChainsBonusGamePreview.vue?vue&type=script&lang=js&"
export * from "./ChainsBonusGamePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports